import { useState } from "react";
import useEventEmitter, { emitEvent } from "../../../hooks/useEventEmitter";
import CommonModal from "../../../components/CommonModal";
import { useTranslation } from "react-i18next";

const DELETE_FILTER_MODAL_EVENT = "DELETE_FILTER_MODAL_EVENT";

export function toggleDeleteFilterModal(filterId?: string, filterName?: string) {
  emitEvent(DELETE_FILTER_MODAL_EVENT, { filterId, filterName });
}

interface DeleteFilterModalProps {
  onConfirm?: (filterId: string) => void;
}


const DeleteFilterModal: React.FC<DeleteFilterModalProps> = ({ onConfirm }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [filterId, setFilterId] = useState<string | null>(null);
  const [filterName, setFilterName] = useState<string | null>(null);
const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setFilterId(null);
    setFilterName(null);
  };

 useEventEmitter(
  DELETE_FILTER_MODAL_EVENT,
  (payload?: { filterId?: string; filterName?: string }) => {
    if (payload?.filterId) {
      setFilterId(payload.filterId);
      setFilterName(payload.filterName ?? "");
      setOpen(true);
    }
  }
);


  const handleConfirm = async () => {
  if (!filterId || loading) return;

  if (typeof onConfirm === "function") {
    try {
      setLoading(true);
      await onConfirm(filterId); // ✅ wait for delete
      handleClose();             // ✅ close AFTER success
    } finally {
      setLoading(false);
    }
  }
};



  return (
    <CommonModal
      open={open}
      onClose={handleClose}
      title="Delete_Filter_Modal_Heading"
     description={t("Delete_Filter_Modal_Desc", {
  filterName: filterName ?? "",
})}
      buttonArray={[
        {
          text: t("Cancel"),
          onClick: handleClose,
          disabled: loading,
          variant: "outlined",
          sx: {
            color: "custom.foreground.purple",
            borderColor: "custom.foreground.purple",
          },
        },
        {
          text: t("Confirm"),
          onClick: handleConfirm,
          sx: {
            backgroundColor: "custom.foreground.purple",
          },
        },
      ]}
    />
  );
};

export default DeleteFilterModal;
